import { Box, BoxProps, ButtonNew, Text } from '@jfs/ui-new'
import * as React from 'react'
import { FC } from 'react'
import { staticStrings } from '../../../data/static/strings'
import { APIEndPoints } from '../../../network/APIEndpoints'
import { useWindowDimensions } from '../../../util/util'

interface FooterProps {
  title?: string
}

const styles = (breakpoint: number) => {
  let overRideContainer: BoxProps = {}
  const isMobile = breakpoint < 600
  if (isMobile) {
    overRideContainer = {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      minHeight: 140,
    } as BoxProps
  }
  return {
    container: {
      flexDirection: 'row',
      marginHorizontal: 16,
      marginTop: 16,
      marginBottom: isMobile ? 20 : 16,
      alignItems: 'center',
      zIndex: -1,
      ...overRideContainer,
    } as BoxProps,
    buttonContainer: {
      display: 'flex',
      marginLeft: isMobile ? -10 : 8,
    } as BoxProps,
  }
}
const handleAgreementNavigation = (): void => {
  window.open(APIEndPoints.merchantAgreement, staticStrings.targetBlank)
}

const handleTncNavigation = (): void => {
  window.open(APIEndPoints.tnc, staticStrings.targetBlank)
}

const handlePrivacyPolicyNavigation = (): void => {
  window.open(APIEndPoints.privactPolicy, staticStrings.targetBlank)
}

const handleGrevienceRedressalNavigation = (): void => {
  window.open(APIEndPoints.grevienceRedressal, staticStrings.targetBlank)
}

const handleKycAMLNavigation = (): void => {
  window.open(APIEndPoints.grevienceRedressal, staticStrings.targetBlank)
}

const btnArray = [
  {
    title: staticStrings.tnc,
    onPress: handleTncNavigation,
  },
  {
    title: staticStrings.privacyPolicy,
    onPress: handlePrivacyPolicyNavigation,
  },
  {
    title: staticStrings.grevienceRedressal,
    onPress: handleGrevienceRedressalNavigation,
  },
  {
    title: staticStrings.kycAML,
    onPress: handleKycAMLNavigation,
  },
]

const getButton = (i: number, viewPortWidth: number): React.ReactElement => {
  return (
    <Box {...styles(viewPortWidth).buttonContainer} key={btnArray[i].title}>
      <ButtonNew
        textDecorationLine={'underline'}
        type={'custom'}
        color={'transparent'}
        titleColor={'BRAND_COLOR_GRAY_1'}
        hoverColor={'transparent'}
        underlayColor={'transparent'}
        textType={'label'}
        testID={'footer-links-'}
        onPress={btnArray[i].onPress}
        title={btnArray[i].title}
      />
    </Box>
  )
}

const getButtons = (count: number, viewPortWidth: number): React.ReactElement[] => {
  const btns = []
  for (let i = 0; i < count; i += 1) {
    btns.push(getButton(i, viewPortWidth))
  }
  return btns
}

const Footer: FC<FooterProps> = () => {
  const width = useWindowDimensions()

  return (
    <Box {...styles(width).container}>
      <Text fontSize={12} color="PRIMARY_GREY" fontWeight="700">
        {staticStrings.labelCopyright}
      </Text>
      {getButtons(btnArray.length, width)}
    </Box>
  )
}

export default Footer
